import { AnimatePresence } from 'motion/react';
import { useSelector } from 'react-redux';

import { useCloseCurrentContext } from '~/hooks/use-close-context';
import { selectLimitsModalData } from '~/components/account/ducks';
import useTranslations from '~/components/translation/use-translations';

import { animationTransition, animationVariants, textKeys } from './constants';
import { AnimatedWrapper, ModalWrapper } from './styled';
import SpendingLimits from './spending-limit';
import RGLimit from './rg-limits';

const LimitsModal = ({ qdLimitsFlow }: { qdLimitsFlow: boolean }) => {
	const { responsibleGamingLimitType, isNlSpendLimitPopup } = useSelector(selectLimitsModalData) ?? {};
	const { isLoadingTranslations } = useTranslations(textKeys);
	const closeCurrentContext = useCloseCurrentContext();

	if (!responsibleGamingLimitType) {
		if (qdLimitsFlow) {
			closeCurrentContext();
		}

		return null;
	}

	return (
		<ModalWrapper show={!isLoadingTranslations} modalWidth={377} blurBg>
			<AnimatePresence mode="wait">
				<AnimatedWrapper
					variants={animationVariants}
					initial="closed"
					animate="open"
					exit="exit"
					transition={animationTransition}
					key="slideUp"
				>
					{isNlSpendLimitPopup ? <SpendingLimits /> : <RGLimit />}
				</AnimatedWrapper>
			</AnimatePresence>
		</ModalWrapper>
	);
};

export default LimitsModal;
